/**
 * Accounting Tracking API Service
 */

import { apiClient } from '../client';
import type { ApiResponse, PaginatedData } from '../../types';
import type {
  AccountingSummary,
  AccountingCompletedItem,
  AccountingAcceptanceItem,
} from '../../types/accounting';

const API_PREFIX = '/api/saiens/accounting';

interface AccountingListParams {
  offset?: number;
  limit?: number;
  search?: string;
  my_orders?: boolean;
}

export async function getAccountingSummary(
  params: { my_orders?: boolean } = {},
): Promise<ApiResponse<AccountingSummary>> {
  const response = await apiClient.get<ApiResponse<AccountingSummary>>(
    `${API_PREFIX}/summary`,
    { params },
  );
  return response.data;
}

export async function getCompletedList(
  params: AccountingListParams = {},
): Promise<ApiResponse<PaginatedData<AccountingCompletedItem>>> {
  const response = await apiClient.get<ApiResponse<PaginatedData<AccountingCompletedItem>>>(
    `${API_PREFIX}/completed`,
    { params },
  );
  return response.data;
}

export async function getAcceptedList(
  params: AccountingListParams = {},
): Promise<ApiResponse<PaginatedData<AccountingAcceptanceItem>>> {
  const response = await apiClient.get<ApiResponse<PaginatedData<AccountingAcceptanceItem>>>(
    `${API_PREFIX}/accepted`,
    { params },
  );
  return response.data;
}

export async function getInvoicedList(
  params: AccountingListParams = {},
): Promise<ApiResponse<PaginatedData<AccountingAcceptanceItem>>> {
  const response = await apiClient.get<ApiResponse<PaginatedData<AccountingAcceptanceItem>>>(
    `${API_PREFIX}/invoiced`,
    { params },
  );
  return response.data;
}

export async function getPaidList(
  params: AccountingListParams = {},
): Promise<ApiResponse<PaginatedData<AccountingAcceptanceItem>>> {
  const response = await apiClient.get<ApiResponse<PaginatedData<AccountingAcceptanceItem>>>(
    `${API_PREFIX}/paid`,
    { params },
  );
  return response.data;
}

export async function getDraftList(
  params: AccountingListParams = {},
): Promise<ApiResponse<PaginatedData<AccountingAcceptanceItem>>> {
  const response = await apiClient.get<ApiResponse<PaginatedData<AccountingAcceptanceItem>>>(
    `${API_PREFIX}/overview/draft`,
    { params },
  );
  return response.data;
}
